import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/base.scss';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import '@kangc/v-md-editor/lib/style/preview.css';
import { globalRegister } from './global'; // 导入element-ui组件
import hljs from 'highlight.js';
import json from 'highlight.js/lib/languages/json'; // 按需引入语言包

// md文件预览组件集成
const githubTheme = require('@kangc/v-md-editor/lib/theme/github.js');

const VMdPreview = require('@kangc/v-md-editor/lib/preview');

hljs.registerLanguage('json', json);

VMdPreview.use(githubTheme, {
  Hljs: hljs
});

createApp(App).use(store).use(router).use(globalRegister).use(VMdPreview).mount('#app');
